import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.93.2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.93.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/(homepage)/_components/TestimonialsRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyDriveButton"] */ "/app/src/components/BuyDriveButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DiscoverDriveButton"] */ "/app/src/components/DiscoverDriveButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandWordmark"] */ "/app/src/components/ui/BrandWordmark.tsx");
